var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { completedPage, startedHomeUnlinkedApplication, } from "../../../lib/Avo";
import AppBody from "../../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../../components/Header";
import Image from "../../../components/Image";
import { PHASE } from "../../../routeConfig";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
import useAppSelector from "../../../hooks/useAppSelector";
import { useDidMount } from "rooks";
import { useHistory } from "react-router-dom";
export default function UnlinkedApplicationHomeownersIntro() {
    var push = useHistory().push;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    function handleClick() {
        completedPage(__assign({ selectedOption: "Continue", optionSelected: "Continue" }, commonAnalyticsProperties));
        push(PHASE.HOME_SELECT_ISSUER);
    }
    useDidMount(function () {
        startedHomeUnlinkedApplication(commonAnalyticsProperties);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, { className: "px-6 pt-20" },
            React.createElement("div", { className: "mx-auto mb-6 flex items-center justify-center" },
                React.createElement(Image, { src: "/assets/icons/green-checkmark.svg", width: 48, height: 48, alt: "" })),
            React.createElement("h2", { className: "mb-2 text-center text-xl font-bold" },
                "Nice!",
                React.createElement("br", null),
                "You completed your",
                React.createElement("br", null),
                "auto policy profile."),
            React.createElement("p", { className: "mb-6 text-center text-black-300" }, "Next, let\u2019s set up your home policy profile."),
            React.createElement(Button, { onClick: handleClick }, "Continue"))));
}
